<template>
  <section class="flex">
    <section class="move-transfer-queue">
      <div class="header">
        <p>Move to Transfer Queue</p>
        <v-button
          class="cancel"
          @click="() => $emit('cancel')">Cancel</v-button>
      </div>
      <div class="tips">Are you sure you want to move this request to the Credit Queue?</div>
      <div class="table">
        <div class="tr">
          <span>Type</span>
          <span>Credit Card</span>
        </div>
      </div>
      <div class="table strip">
        <div class="tr">
          <span>Transfer Amount</span>
          <span>{{ form.money }}</span>
        </div>
        <div class="tr">
          <span>Cardholder Name</span>
          <span>{{ form.card_holder }}</span>
        </div>
        <div class="tr">
          <span>Issuing Bank</span>
          <span>{{ form.card_bank }}</span>
        </div>
        <div class="tr">
          <span>Credit Card Number</span>
          <span>{{ form.card_number }}</span>
        </div>
      </div>
      <v-button
        class="success"
        @click="onAddQueue">Confirm & Move To Queue</v-button>

    </section>
    <div class="right">
      <div class="box-remark">
        <span class="title">Remarks</span>
        <div class="remarks-container">
          <div
            v-for="(item, index) in remarkLogsData"
            :key="index"
            class="remark-box">
            <div class="remark-header">
              <span>{{ item.agent }}</span>
              <span>{{ item.created_at }}</span>
            </div>
            <p>{{ item.message }}</p>
          </div>
        </div>
        <div class="remark-add">
          <v-input
            v-model="message"
            class="mg-b-15"
            append="Add"
            @handlerAppend="handlerSendRemark"/>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { addCreditTransferQueue } from '@/api/credits'
export default {
  name: 'MoveTransferQueue',
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
    remarkDetail:{
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      message: '' 
    }
  },
  computed:{
    remarkLogsData(){
      return this.remarkDetail || []
    }
  },
  methods: {
    onAddQueue() {
      // this.$parent.sendSms()
      this.network().addCreditTransferQueue()
    },
    handlerSendRemark(){
      this.$emit('sendRemark', this.message)
      this.message = ''
    },
    network() {
      return {
        addCreditTransferQueue: async (params) => {
          const { data } = await addCreditTransferQueue({
            transfer_id: [this.form.id],
            ...params
          })
          this.$message({
            type: 'success',
            message: 'Success'
          })
          this.$emit('success')
          // this.$parent.$refs['send-email-sms-transfer'].changeDialog()
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.move-transfer-queue {
  padding: 15px;
  flex: 1;
  .header{
    display: flex;
    justify-content: space-between;
    p{
      font-weight: 600;
      font-size: 20px;
      line-height: 30px;
      height: 30px;
      color: #24292E;
    }
    .cancel{
      font-weight: 600;
      font-size: 14px;
      color: #24292E;
      height: 32px;
      border-radius: 6px;
    }
  }
  .tips{
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    height: 20px;
    color: #24292E;
    margin: 20px 0;
  }
  h3 {
    padding: 10px 0 15px 0;
  }
  .table {
    .tr {
      padding: 8px 16px;
      border: 1px solid #D1D5DA;
      background: #fff!important;
      display: flex;
      height: 36px;
      span{
        &:first-child{
          color: #586069;
          font-weight: 600;
          font-size: 14px;
        }
        &:last-child{
          color: #24292E;
          font-weight: 400;
          font-size: 14px;
        }
      }
      & + .tr{
        border-top: 0;
      }
      &:first-child{
        border-top-left-radius: 6px;
        border-top-right-radius: 6px;
      }
      &:last-child{
        border-bottom-left-radius: 6px;
        border-bottom-right-radius: 6px;
      }
    }
  }
  .success{
    background: #2EA44F;
    border: 1px solid rgba(27, 31, 35, 0.15);
    box-shadow: 0px 1px 0px rgba(27, 31, 35, 0.1);
    border-radius: 6px;
    color: #FFFFFF;
  }
}
.right{
  margin-left: 30px;
  width: 280px;
  .box-remark{
    padding: 29.5px 0;
    .remarks-container {
      z-index: 1;
      max-height: 300px;
      overflow-y: auto;
  
      .remark-box {
        margin-bottom: 10px;
        font-size: 12px;
        color: #91939a;
  
        .remark-header {
          display: flex;
          justify-content: space-between;
  
          span:first-child {
            font-weight: bold;
          }
        }
  
        p {
          padding-bottom: 10px;
          color: #616266;
        }
      }
    }
    .remark-add {
      z-index: 2;
      margin: 0 -15px;
      padding: 15px 15px 0 15px;
    }
  }
}
</style>